import React from 'react'

const Error = () => {
  return (
    <div style={{display:'flex',justifyContent:'center',margin:'1em 0 2em 40%'}}>
        <img  src='https://static.wixstatic.com/media/a1d2f8_d3e9823ee90744db8e45d63527bfb4bb~mv2.png/v1/fill/w_560,h_306,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/a1d2f8_d3e9823ee90744db8e45d63527bfb4bb~mv2.png' alt='oops'></img>
    </div>
  )
}

export default Error